var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/add-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 1.66663C5.40835 1.66663 1.66669 5.40829 1.66669 9.99996C1.66669 14.5916 5.40835 18.3333 10 18.3333C14.5917 18.3333 18.3334 14.5916 18.3334 9.99996C18.3334 5.40829 14.5917 1.66663 10 1.66663ZM13.3334 10.625H10.625V13.3333C10.625 13.675 10.3417 13.9583 10 13.9583C9.65835 13.9583 9.37502 13.675 9.37502 13.3333V10.625H6.66669C6.32502 10.625 6.04169 10.3416 6.04169 9.99996C6.04169 9.65829 6.32502 9.37496 6.66669 9.37496H9.37502V6.66663C9.37502 6.32496 9.65835 6.04163 10 6.04163C10.3417 6.04163 10.625 6.32496 10.625 6.66663V9.37496H13.3334C13.675 9.37496 13.9584 9.65829 13.9584 9.99996C13.9584 10.3416 13.675 10.625 13.3334 10.625Z",
    fill: "#6933FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.f9ee3e3e3cadb8efc4a1f5240fbc2126.svg";
export { ForwardRef as ReactComponent };